import React from 'react';
import PropTypes from 'prop-types';

import { LoginPageLogo, Text } from 'components/common/Elements/Elements';

import classes from './LoginHeader.module.scss';

const LoginHeader = ({ text }) => {
  return (
    <div className={classes.login_header}>
      <LoginPageLogo />
      <Text size={8}>{text}</Text>
    </div>
  );
};

LoginHeader.propTypes = {
  text: PropTypes.string
};

export default LoginHeader;
